let config = {
  userPoolId: '',
  clientId: '',
  apiUrl: '',
  uploadBucket: '',
};

const loadConfig = async () => {
  try {
    const res = await fetch('/config.json');
    if (res.ok) {
      const json = await res.json();
      Object.assign(config, json);
    }
  } catch {
    // Fall back to env vars for local dev
  }
  config.userPoolId = config.userPoolId || process.env.REACT_APP_USER_POOL_ID || '';
  config.clientId = config.clientId || process.env.REACT_APP_USER_POOL_CLIENT_ID || '';
  config.apiUrl = config.apiUrl || process.env.REACT_APP_API_URL || '';
  config.uploadBucket = config.uploadBucket || process.env.REACT_APP_UPLOAD_BUCKET || '';
  return config;
};

export { loadConfig };
export default config;
